import type { JSX } from 'react';
import Box from '@mui/material/Box';
import type { AppLocale } from '@/types/common.types';

function EnFlagIcon() {
  return (
    <svg viewBox="0 0 60 60" width="100%" height="100%" role="img" aria-hidden="true">
      <rect width="60" height="60" fill="#00247d" />
      <path d="M0 0 60 60M60 0 0 60" stroke="#ffffff" strokeWidth="13" />
      <path d="M0 0 60 60M60 0 0 60" stroke="#cf142b" strokeWidth="4.5" />
      <path d="M30 0V60M0 30H60" stroke="#ffffff" strokeWidth="20" />
      <path d="M30 0V60M0 30H60" stroke="#cf142b" strokeWidth="12" />
    </svg>
  );
}

function DeFlagIcon() {
  return (
    <svg viewBox="0 0 60 60" width="100%" height="100%" role="img" aria-hidden="true">
      <rect width="60" height="20" y="0" fill="#000000" />
      <rect width="60" height="20" y="20" fill="#dd0000" />
      <rect width="60" height="20" y="40" fill="#ffce00" />
    </svg>
  );
}

export const LOCALE_OPTIONS: AppLocale[] = ['en', 'de'];

const LOCALE_FLAGS: Record<AppLocale, () => JSX.Element> = {
  en: EnFlagIcon,
  de: DeFlagIcon,
};

interface LocaleFlagProps {
  locale: AppLocale;
  size?: number;
}

export function LocaleFlag({ locale, size = 20 }: LocaleFlagProps) {
  const FlagIcon = LOCALE_FLAGS[locale];

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        overflow: 'hidden',
        display: 'flex',
        flexShrink: 0,
        boxShadow: '0 0 0 1px rgba(0,0,0,0.15)',
      }}
    >
      <FlagIcon />
    </Box>
  );
}
